var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.user)?_c('user-form',{ref:"form",on:{"valid":(val) => _vm.$emit('valid', val),"pending":() => _vm.$emit('pendingFile'),"uploadedFile":() => _vm.$emit('uploadedFile')},model:{value:(_vm.user),callback:function ($$v) {_vm.user=$$v},expression:"user"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }